import { render, staticRenderFns } from "./EditableSpan.vue?vue&type=template&id=cf4a182e&scoped=true&"
import script from "./EditableSpan.vue?vue&type=script&lang=js&"
export * from "./EditableSpan.vue?vue&type=script&lang=js&"
import style0 from "./EditableSpan.vue?vue&type=style&index=0&id=cf4a182e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf4a182e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
